import styled from 'styled-components';

export const MainHeader = styled.div`
    padding-top: 2rem;
    padding-bottom: 6rem;
`;
